import { Injector, NgModule } from '@angular/core';
import { AuthHttpModule } from '../services/auth-http.module';
import { UsersAPI } from './users.api';
import { RoutinesAPI } from './routines.api';
import { UsersGroupsAPI } from './users_groups.api';
import { BanksAPI } from './banks.api';
import { ProcessAPI } from './process.api';
import { CommissionsAPI } from './commissions.api';
import { ProposalsAPI } from './proposals.api';
import { StatusCustomersAPI } from './status_customers.api';
import { StatusProcessAPI } from './status_process.api';
import { CustomersAPI } from './customers.api';
import { LeadsAPI } from './leads.api';
import { DashboardAPI } from './dashboard.api';
import { ChannelsAPI } from './channels.api';
import { IncorporadoraAPI } from './incorporadora.api';
import { EmpreendimentosAPI } from './empreendimento.api';
import { EdificiosAPI } from './edificios.api';
import { UnidadesAPI } from './unidades.api';
import { ControleChatsAPI } from './controle_chats.api';
import { HonorariosParcelasAPI } from './honorarios_parcelas.api';
import { EmployeesAPI } from './employees.api';
@NgModule({
	imports: [
		AuthHttpModule
	],
	providers: [
		UsersAPI,
		RoutinesAPI,
		UsersGroupsAPI,
		BanksAPI,
		ProcessAPI,
		CommissionsAPI,
		ProposalsAPI,
		StatusCustomersAPI,
		StatusProcessAPI,
		CustomersAPI,
		LeadsAPI,
		DashboardAPI,
		ChannelsAPI,
		IncorporadoraAPI,
		EmpreendimentosAPI,
		EdificiosAPI,
		UnidadesAPI,
		ControleChatsAPI,
		HonorariosParcelasAPI,
		EmployeesAPI
	],
})
export class APIModule { }


// WEBPACK FOOTER //
// ./src/api/api.module.ts